import React from 'react';
import './Header.css';
import {Stack,Box,TextField} from '@mui/material';
import { Link } from 'react-router-dom';
import SearchIcon from "@mui/icons-material/Search";
import Upload from './Upload';
const Header = ({handleSearch,isVideoPage})=>{

    return(
        <Box sx={{backgroundColor:'#202020'}}>
            <Stack direction="row" sx={{justifyContent:'space-between',paddingTop:'13px'}}>
                <Link to='/'>
                    <img src="/Logo.svg" alt="" style={{marginLeft:'24px'}}/>
                </Link>
                {!isVideoPage && 
                <Box className='search-container'>
                    <input placeholder="Search" className='search-input' onChange={handleSearch}></input>
                    <button className='search-button'><SearchIcon/></button>
                </Box>}
                {!isVideoPage &&
                <Box>
                    <Upload/>
                </Box>}
        
            </Stack>
        </Box>
    )
    
}

export default Header